// extracted by mini-css-extract-plugin
export default {"btnHolder":"CategoryLevelTwoTable_btnHolder__LY7wq","deleteBtn":"CategoryLevelTwoTable_deleteBtn__TvDxf","ok":"CategoryLevelTwoTable_ok__xOzhd"};